(() => {
  const onReady = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn, { once: true }) : fn();

  onReady(() => {
    document.body.classList.add('abastik-motion-ready');

    const buttonSelector = [
      '#MainContent a.primary',
      '#MainContent a.secondary',
      '#MainContent a.btn',
      '#MainContent .view-product',
      '#MainContent .add-cart',
      '#MainContent .wa',
      '#MainContent .store'
    ].join(',');
    const buttons = [...document.querySelectorAll(buttonSelector)];
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('abastik-button-in');
          obs.unobserve(entry.target);
        });
      }, { threshold: .18, rootMargin: '0px 0px -4% 0px' });
      buttons.forEach((button, index) => {
        button.style.transitionDelay = `${Math.min(index % 3, 2) * 70}ms`;
        observer.observe(button);
      });
    } else {
      buttons.forEach((button) => button.classList.add('abastik-button-in'));
    }

    const finePointer = window.matchMedia('(hover:hover) and (pointer:fine) and (prefers-reduced-motion:no-preference)');
    if (!finePointer.matches) return;

    const count = 5;
    const eggs = [];
    const positions = Array.from({ length: count }, () => ({ x: -80, y: -80 }));
    let target = { x: -80, y: -80 };
    let active = false;
    let frame = 0;
    let lastMove = 0;

    for (let i = 0; i < count; i++) {
      const egg = document.createElement('span');
      egg.className = 'abastik-cursor-egg';
      egg.style.setProperty('--egg-scale', String(1 - i * .08));
      egg.style.zIndex = String(999997 - i);
      document.body.appendChild(egg);
      eggs.push(egg);
    }

    const render = (time) => {
      const stillMoving = time - lastMove < 220;
      const settle = time - lastMove < 900;
      positions[0].x += (target.x - 24 - positions[0].x) * .24;
      positions[0].y += (target.y + 18 - positions[0].y) * .24;
      for (let i = 1; i < count; i++) {
        positions[i].x += (positions[i - 1].x - 17 - positions[i].x) * (.25 - i * .018);
        positions[i].y += (positions[i - 1].y + 2 - positions[i].y) * (.25 - i * .018);
      }

      eggs.forEach((egg, i) => {
        const p = positions[i];
        const bounce = stillMoving ? Math.sin((time / 95) - i * .9) * 2.1 : 0;
        egg.style.transform = `translate3d(${p.x}px,${p.y + bounce}px,0) scale(${1 - i * .08}) rotate(${Math.sin(time / 150 + i) * 3}deg)`;
        egg.style.opacity = active ? String(Math.max(.25, .92 - i * .13)) : '0';
        egg.classList.toggle('is-running', stillMoving);
      });

      if (active && settle) frame = requestAnimationFrame(render);
      else frame = 0;
    };

    window.addEventListener('pointermove', (event) => {
      target.x = event.clientX;
      target.y = event.clientY;
      lastMove = performance.now();
      active = true;
      if (!frame) frame = requestAnimationFrame(render);
    }, { passive: true });

    document.documentElement.addEventListener('mouseleave', () => {
      active = false;
      eggs.forEach((egg) => egg.style.opacity = '0');
    });
  });
})();
